export default "__VITE_ASSET__c2089d1a__"